import Box from '@mui/material/Box';
import React from 'react';

const Scene = ({ className = undefined, noMargin = false, noBar = false, noTopBar, noMenu, ...props }) => {
  return (
    <Box
      sx={[
        noBar
          ? {
              height: 'calc(100vh - 104px)',
              overflowY: 'auto',
            }
          : { height: 'calc(100vh - 168px)', overflowY: 'auto' },
      ]}
    >
      <Box
        className={className}
        sx={[
          {
            overflowX: 'hidden',
          },
        ]}
        {...props}
      />
    </Box>
  );
};

export default Scene;
